const AlgoliaSearchConfigLiveBrands = {
  hitsPerPage: 10,
  facetFilters: [["is_published:true"], ["status:APPROVED", "status:REGISTERED"]],
};
export default {
  getAllAlgoliaResults,
  truncate,
};

/*
 * a recursive function that gets all pages of results from an algolia seach
 * and returns a callback with an array of results
 */
function getAllAlgoliaResults(page, brandList, searchIndex, callback) {
  const searchConfigWithPage = AlgoliaSearchConfigLiveBrands;
  searchConfigWithPage.page = page;
  searchIndex.search(searchConfigWithPage).then((response) => {
    brandList = [
      ...brandList,
      ...response.hits.map((hit) => ({
        entity_id: hit.id,
        component_type: "BRAND",
        image_url: hit.thumbnail_image_url,
        name: hit.brand_name,
        mov: hit.minimum_order_value,
        vanity_url_name: hit.vanity_url_name,
      })),
    ];

    if (page === response.nbPages - 1) {
      callback(brandList);
    } else {
      page += 1;
      getAllAlgoliaResults(page, brandList, searchIndex, callback);
    }
  });
}

function truncate(array) {
  const limit = 8;
  return array.filter((filter, i) => i < limit);
}
